import { COLORS } from 'helpers/globals'

const container = {
  display: 'flex',
  flexDirection: 'column',
  color: 'black',
  width: '100%'
}

const table = {
  marginBottom: '.8rem',
  fontWeight: 300,
  '& th': {
    padding: '1px',
    fontWeight: 500,
    '&:not(:first-of-type)': { textAlign: 'right' }
  },
  '& td': {
    padding: '.5rem',
    border: 'none',
    '&:not(:first-of-type)': { textAlign: 'right' }
  },
  '& > tbody > tr': {
    '&:nth-child(even)': {
      background: COLORS.tertiary
    }
  }
}

export default {
  container,
  exportContainer: {
    ...container,
    padding: '0 0.5rem',
    '& strong': {
      fontSize: '2.2rem',
      fontWeight: 400
    }
  },
  doorExportContainer: {
    ...container,
    padding: '.5rem 1rem 0 1rem',
    '& strong': {
      fontSize: '2rem',
      fontWeight: 400
    }
  },
  table,
  exportTable: {
    ...table,
    padding: '0 0.5rem',
    fontSize: '1.8rem'
  },
  helpIcon: {
    marginLeft: '.5rem'
  }
}



// WEBPACK FOOTER //
// ./src/components/DoorEntityConfigurationSummary/style.js